import { useDisclosure } from '@chakra-ui/react';

import { PrivatlivsPolitik } from '../PrivatlivsPolitik';

const Footer = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <footer className="section-alt">
        <div className="section-wrap" style={{ paddingBlock: '2rem' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: '1rem',
              flexWrap: 'wrap',
            }}
          >
            <p style={{ margin: 0, color: 'var(--muted)', fontSize: '0.84rem' }}>
              © Toft Ejendomme {new Date().getFullYear()} · v/Torben Toft Nielsen · CVR 27582915
            </p>

            <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
              <button
                className="site-footer-link"
                onClick={onOpen}
                style={{
                  background: 'none',
                  border: 0,
                  padding: 0,
                  color: 'var(--muted)',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  textUnderlineOffset: '0.18rem',
                }}
                type="button"
              >
                Behandling af personlige oplysninger
              </button>
              <a className="site-footer-link" href="mailto:info@toftejendomme.dk">
                info@toftejendomme.dk
              </a>
            </div>
          </div>
        </div>
      </footer>

      <PrivatlivsPolitik isOpen={isOpen} onOpen={onOpen} onClose={onClose} />
    </>
  );
};

export default Footer;
